import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
  loadingDetail: false,
  dataDetail: null,
  errorsDetail: null,
}

export const getters = {
  getShowList(state) {
    return state.data
  },
  getNotificationDetails(state) {
    return state.dataDetail
  },
}

export const mutations = {
  SET_SHOW_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_SHOW_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_SHOW_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  SET_NOTIFICATION_DETAILS_REQUESTED(state) {
    state.loadingDetail = true
  },
  SET_NOTIFICATION_DETAILS_RECEIVED(state, newData) {
    state.loadingDetail = false
    state.dataDetail = newData
    state.errorsDetail = null
  },
  SET_NOTIFICATION_DETAILS_RECEIVED_FAILED(state, error) {
    state.loadingDetail = false
    state.errorsDetail = error
  },
}

export const actions = {
  async fetchingShowList({ commit }, params) {
    commit('SET_SHOW_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/notification/show/',
        payload: { ...params },
      })
      commit('SET_SHOW_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_SHOW_LIST_RECEIVED_FAILED', error)
    }
  },
  async fetchingNotificationDetails({ commit }, params) {
    commit('SET_NOTIFICATION_DETAILS_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/notification/get/',
        payload: { ...params },
      })
      commit('SET_NOTIFICATION_DETAILS_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_NOTIFICATION_DETAILS_RECEIVED_FAILED', error)
    }
  },
}
